import { TTrialModalState } from './trialModalModel';

export const trialModalInitialState: TTrialModalState = {
  isModalVisible: false,
  timerId: null
};
